import React from 'react';
import Header from '../../components/Header';
import Footer from '../../components/Footer';

const KullanimKosullari = () => {
    return (
        <div className="legal-page">
            <div className="legal-container">
                <h1>Kullanım Koşulları</h1>
                <div className="legal-content">
                <p><strong>Son Güncelleme:</strong> 01/01/2025</p>

                <p>Lütfen web sitemizi kullanmadan önce bu kullanım koşullarını dikkatlice okuyunuz. Web sitemizi ziyaret ederek ve kullanarak bu koşulları kabul etmiş sayılırsınız. Kabul etmemeniz halinde lütfen siteyi kullanmayınız.</p>

                <h3>1. Hizmetin Kapsamı</h3>
                <p>Black owLs Gaming Community olarak sizlere çevrim içi içerik, hizmet ve topluluk etkileşimleri sunmaktayız. Sunduğumuz hizmetler, belirli kurallar ve kısıtlamalar çerçevesinde sağlanır ve zaman zaman güncellenebilir.</p>

                <h3>2. Kullanıcı Yükümlülükleri</h3>
                <p>Web sitemizi kullanırken:</p>
                <ul>
                    <li>Yasalara, ahlaki kurallara ve topluluk kurallarımıza uygun davranmalısınız.</li>
                    <li>Web sitemizi kötüye kullanmamalı, başkalarının haklarına zarar vermemelisiniz.</li>
                    <li>Yanıltıcı, zararlı veya yasadışı içerik paylaşmamalısınız.</li>
                    <li>Hesap bilgilerinizin gizliliğini korumak sizin sorumluluğunuzdadır.</li>
                </ul>

                <h3>3. Hesap Güvenliği</h3>
                <p>Hesabınızın güvenliğinden ve tüm aktivitelerden siz sorumlusunuz. Şifrenizin veya hesap bilgilerinizin izinsiz kullanıldığını düşünüyorsanız derhal bizimle iletişime geçmelisiniz.</p>

                <h3>4. İçerik ve Fikri Mülkiyet Hakları</h3>
                <p>Web sitemizde yer alan tüm içerikler (metin, görseller, logo vb.) Black owLs Gaming Community'ye aittir veya lisans altında kullanılmaktadır. İzinsiz kopyalanması veya kullanılması yasaktır.</p>

                <h3>5. Hizmet Kesintileri ve Değişiklikler</h3>
                <p>Web sitemizden sunduğumuz hizmetlerin kesintiye uğramasından veya değişmesinden kaynaklanan zararlardan sorumlu tutulamayız.</p>
                <p>Herhangi bir bildirimde bulunmaksızın hizmetleri sonlandırma veya değiştirme hakkımız saklıdır.</p>

                <h3>6. Üçüncü Taraf Bağlantıları</h3>
                <p>Web sitemizde yer alan üçüncü taraf sitelere verilen bağlantılar yalnızca bilgi amaçlıdır ve bu sitelerin içeriklerinden sorumlu tutulamayız.</p>

                <h3>7. Fesih ve Askıya Alma</h3>
                <p>Kullanıcıların bu kurallara aykırı davranması halinde, hesapları kısmen veya tamamen askıya alınabilir ya da kalıcı olarak sonlandırılabilir.</p>
                <p>Kullanıcıların hesaplarının sonlandırılmasından kaynaklanan veri kayıpları veya zararlar konusunda sorumluluk kabul edilmez.</p>

                <h3>8. Sorumluluk Reddi</h3>
                <p>Web sitemizi kullanmanız tamamen sizin sorumluluğunuzdadır. Hizmetlerimiz "olduğu gibi" ve "mevcut haliyle" sağlanır. Teknik aksaklıklar, hatalar veya eksikliklerden dolayı oluşabilecek sorunlarda sorumluluk kabul edilmez.</p>

                <h3>9. Değişiklikler</h3>
                <p>Bu kullanım koşulları zaman zaman güncellenebilir. Güncel koşullar, web sitemizde yayınlandığı tarihten itibaren geçerli sayılacaktır.</p>

                <h3>10. İletişim</h3>
                <p>Kullanım koşullarımızla ilgili her türlü soru ve görüşleriniz için bizimle <a href="mailto:blackowlsresmi@gmail.com">blackowlsresmi@gmail.com</a> adresi üzerinden iletişime geçebilirsiniz.</p>
                </div>
            </div>
        </div>
    );
};

export default KullanimKosullari;